import React from "react";
import EnergyAssetsCard from "./EnergyAssetsCard";

const ThermalPower = ({ energyAssetsData }) => {
  const ThermalPowerPlants = energyAssetsData.filter(
    (plant) => plant.field_category_page_assets === "Thermal Power"
  );

  // Check if there are no hydro power plants
  if (ThermalPowerPlants.length === 0) {
    return <div>No thermal power plants available</div>;
  }

  return (
    <div className="hydro-power-box1b aos-init aos-animate ">
      <ul>
        {ThermalPowerPlants.map((item, index) => (
          <EnergyAssetsCard plantData={item} key={index} />
        ))}
      </ul>
    </div>
  );
};

export default ThermalPower;
